/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable class-methods-use-this */
// eslint-disable-next-line class-methods-use-this

import React from 'react';
import { shareHandlingForTimesPoints } from 'modules/WithTimesPoint/TimesPointUtils';
import EmailSharing from 'components_v2/desktop/EmailSharing/EmailSharingNonPrime';
import { tpShowModalEmitter } from 'modules/WithTimesPointModal/TimesPointModalUtils';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import { getShortUrl } from 'utils/common';
import { toiTitle } from 'routes/home/layouts/India/mobile/constants';
import { bindGa } from 'helpers/analytics';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import PopupPortal from 'components_v2/mobile/PopupPortal/PopupPortal';
import ErrorBoundary from 'components/ErrorBoundary/ErrorBoundary';
import s from './SocialWidget.scss';
import analyticsWrapper from '../../../../../helpers/analytics/analyticsWrapper';

class SocialWidget extends React.Component {
  constructor() {
    super();
    this.state = {
      openEmailPopUp: false,
      showInGeo: true,
    };
    this.openSidebar = this.openSidebar.bind(this);
    this.shareOnTwitter = this.shareOnTwitter.bind(this);
    this.shareOnFb = this.shareOnFb.bind(this);
    this.shareOnLinkedin = this.shareOnLinkedin.bind(this);
    this.shareOnPinterest = this.shareOnPinterest.bind(this);
    this.openEmailPopup = this.openEmailPopup.bind(this);
    this.gaClickHandler = this.gaClickHandler.bind(this);
    this.handleEmailClick = this.handleEmailClick.bind(this);
    this.shareOnWhatsapp = this.shareOnWhatsapp.bind(this);
  }

  componentDidMount() {
    // this.setTimesPointShare();
    if (
      typeof window !== 'undefined' &&
      window.geoinfo &&
      window.geoinfo.CountryCode !== 'IN'
    ) {
      this.setState({ showInGeo: false });
    }
  }

  componentDidUpdate(prevProps) {
    // if (this.props.msid !== prevProps.msid) {
    //   this.setTimesPointShare();
    // }
  }

  @bindGa({})
  openEmailPopup() {
    this.setState({ openEmailPopUp: true });
    document.body.classList.toggle('disable-scroll');
  }

  @bindGa({})
  handleEmailClick() {
    const { url, title, disableShortUrl } = this.props;
    let { utm } = this.props;
    utm = this.getUtmDetail(utm, 'email', url);
    const titleToBeshared = title || toiTitle;
    const urlToBeShared = `${getShortUrl(
      `${url}${utm}`,
      'email',
      true,
      disableShortUrl,
    )}
      \n\nUse the TOI app to get Breaking news and headlines. Download now: \nhttps://timesofindia.onelink.me/efRt/ASmwebshare`;
    const body = `body=${encodeURIComponent(urlToBeShared)}`;
    const intentUrl = `mailto:?subject=TOI: ${titleToBeshared}`;
    window.location.href = `${intentUrl}&${body}`;
  }

  closeEmailPopup = () => {
    this.setState({ openEmailPopUp: false });
    document.body.classList.toggle('disable-scroll');
    if (typeof this.props.socialWidgetToggle === 'function') {
      this.props.socialWidgetToggle();
    }
  };

  setTimesPointShare() {
    if (
      typeof window.TPWidget !== 'undefined' &&
      typeof window.TPWidget.init === 'function' &&
      this.divId
    ) {
      setTimeout(() => {
        window.TPWidget.init({
          widgets: [
            {
              ele: this.divId,
              widgetType: 'tpwidget-two',
              callback() {
                tpShowModalEmitter('tpwidget-two');
              },
            },
          ],
        });
      }, 0);
    }
  }
  commentsRedirectHandling = () => {
    if (this.props.forceOpenSidebar) {
      this.props.openSidebar(this.props.msid);
    } else {
      const url = `https://m.timesofindia.com/articleshow_comments/${
        this.props.msid
      }.cms`;
      window.location = url;
    }
  };

  @bindGa({})
  // eslint-disable-next-line no-unused-vars
  gaClickHandler(e) {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'times_point',
      category: this.props.isLiveBlog
        ? 'liveblog_sticky'
        : 'articleshow_sticky',
    });
  }

  @bindGa({})
  openSidebar() {
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'comments',
      category: this.props.isLiveBlog
        ? 'liveblog_sticky'
        : 'articleshow_sticky',
    });
    if (this.props.isWapView) {
      this.commentsRedirectHandling();
    } else {
      if (!(this.props.isTablet && this.props.isTablet())) {
        document.body.style.overflow = 'hidden';
        document.documentElement.style.overflow = 'hidden';
      }
      this.props.openSidebar(this.props.msid);
    }
  }

  @bindGa({})
  shareOnTwitter(e, msid) {
    const { url, title, wu, disableShortUrl, isAuthorWidget } = this.props;
    let { via, utm } = this.props;
    utm = this.getUtmDetail(utm, 'x', url);
    const _title = title || toiTitle;
    if (typeof via === 'string' && via.indexOf('@') === 0) {
      via = via.substring(1);
    }
    let twitterShareUrl = 'https://twitter.com/intent/tweet?';
    if (isAuthorWidget && url?.twitter) {
      twitterShareUrl = url?.twitter;
      if (typeof window !== 'undefined') {
        window.open(twitterShareUrl, '_blank');
      }
    } else {
      twitterShareUrl += `text=${encodeURIComponent(
        _title,
      )}&via=${via}&url=${encodeURIComponent(
        getShortUrl(
          `${url}${utm}`,
          'twitter',
          this.props.isWapView,
          disableShortUrl,
        ),
      )}&original_referer=${encodeURIComponent(wu)}`;
    }

    window.open(twitterShareUrl, '_blank', 'width=450,height=450');
    shareHandlingForTimesPoints('twitter', msid, this.props.isWapView);
  }

  @bindGa({})
  shareOnFb(e, msid) {
    const { url, disableShortUrl, isAuthorWidget } = this.props;
    let { utm } = this.props;
    utm = this.getUtmDetail(utm, 'facebook', url);
    let fbShareUrl = 'https://www.facebook.com/sharer/sharer.php?';
    if (isAuthorWidget && url?.fb) {
      fbShareUrl = url?.fb;
      if (typeof window !== 'undefined') {
        window.open(fbShareUrl, '_blank');
      }
    } else {
      fbShareUrl += encodeURI(
        `u=${getShortUrl(
          `${url}${utm}`,
          'fb',
          this.props.isWapView,
          disableShortUrl,
        )}`,
      );
    }

    window.open(fbShareUrl, '_blank', 'width=540,height=540');
    shareHandlingForTimesPoints('facebook', msid, this.props.isWapView);
  }

  @bindGa({})
  shareOnLinkedin() {
    const { url, disableShortUrl } = this.props;
    let { utm } = this.props;
    utm = this.getUtmDetail(utm, 'linkedin', url);
    let inShareUrl = 'https://www.linkedin.com/shareArticle/?';
    inShareUrl += encodeURI(
      `url=${getShortUrl(
        `${url}${utm}`,
        'linkedin',
        this.props.isWapView,
        disableShortUrl,
      )}`,
    );
    window.open(inShareUrl, '_blank', 'width=500,height=500');
  }

  @bindGa({})
  shareOnPinterest() {
    const { url, image, disableShortUrl } = this.props;
    let { utm } = this.props;
    utm = this.getUtmDetail(utm, 'pinterest', url);
    let imgToShare = 'https://static.toiimg.com/photo/34824568.cms';
    if (image) {
      const imgElements = image.imageid.split('&');
      if (imgElements.length > 1) {
        imgToShare = `https://static.toiimg.com/photo/msid-${imgElements[0]},${
          imgElements[1]
        }/${image.id}.jpg`;
      } else {
        imgToShare = `https://static.toiimg.com/photo/msid-${imgElements[0]}/${
          image.id
        }.jpg`;
      }
    }
    let pinterestShareUrl = 'https://in.pinterest.com/pin/create/button/?';
    pinterestShareUrl += encodeURI(
      `url=${getShortUrl(
        `${url}${utm}`,
        'pinit',
        this.props.isWapView,
        disableShortUrl,
      )}&media=${imgToShare}`,
    );
    window.open(pinterestShareUrl, '_blank', 'width=500,height=500');
  }

  @bindGa({})
  openComment() {
    const url = `https://m.timesofindia.com/articleshow_comments/${
      this.props.msid
    }.cms`;
    window.location = url;
  }

  @bindGa({})
  shareOnWhatsapp() {
    const { url, title, disableShortUrl } = this.props;
    let { utm } = this.props;
    utm = this.getUtmDetail(utm, 'whatsapp', url);
    const _title = title || toiTitle;
    let whatsappShareUrl = 'https://api.whatsapp.com/send?';
    if (disableShortUrl || utm) {
      whatsappShareUrl += `text= ${encodeURIComponent(
        `${_title} - ${getShortUrl(
          `${url}${utm}`,
          'whatsapp',
          true,
          disableShortUrl,
        )}\n\nUse the TOI app to get Breaking news and headlines. Download now: \nhttps://timesofindia.onelink.me/efRt/ASmwebshare`,
      )}`;
    } else {
      whatsappShareUrl += encodeURI(
        `text=${_title} - ${getShortUrl(
          `${url}${utm}`,
          'whatsapp',
          true,
          disableShortUrl,
        )}\n\nUse the TOI app to get Breaking news and headlines. Download now: \nhttps://timesofindia.onelink.me/efRt/ASmwebshare`,
      );
    }
    window.open(whatsappShareUrl, '_blank', 'width=450,height=450');
  }

  followOnYoutube() {
    const { gaCategory, gaAction, gaIndex, isEtimes } = this.props;
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: gaAction || 'youtube',
        gaLabel: `${gaIndex}youtube`,
      },
    });
    let youtubeFollowUrl = 'https://www.youtube.com/timesofindia';
    if (isEtimes) {
      youtubeFollowUrl = 'https://www.youtube.com/c/ETimes';
    }
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'google',
      label: 'btf_share',
    });
    window.open(youtubeFollowUrl, '_blank');
  }

  likeOnFb() {
    const { gaCategory, gaAction, gaIndex, sectionName, isEtimes } = this.props;
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: gaAction || 'facebook',
        gaLabel: `${gaIndex}facebook`,
      },
    });
    let fbPageUrl = 'https://www.facebook.com/TimesofIndia';
    if (sectionName === 'business') {
      fbPageUrl = 'https://www.facebook.com/toibusiness/';
    } else if (sectionName === 'world') {
      fbPageUrl = 'https://www.facebook.com/toiworldnews/';
    } else if (sectionName === 'sports') {
      fbPageUrl = 'https://www.facebook.com/toisports/';
    }
    if (isEtimes) {
      fbPageUrl = 'https://www.facebook.com/etimesofficial/';
    }
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'facebook',
      label: 'btf_share',
    });
    window.open(fbPageUrl, '_blank');
  }
  followOnTelegram() {
    const { gaCategory, gaAction, gaIndex } = this.props;
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: gaAction || 'telegram',
        gaLabel: `${gaIndex}telegram`,
      },
    });
    const telegramFollowUrl =
      'https://t.me/Timesofindia_News/intent/follow?screen_name=timesofindia';
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'twitter',
      label: 'btf_share',
    });
    window.open(telegramFollowUrl, '_blank');
  }

  followOnTwitter() {
    const { gaCategory, gaAction, gaIndex, sectionName, isEtimes } = this.props;
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: gaAction || 'twitter',
        gaLabel: `${gaIndex}twitter`,
      },
    });
    let twitterFollowUrl =
      'https://twitter.com/intent/follow?screen_name=timesofindia';
    if (sectionName === 'business') {
      twitterFollowUrl =
        'https://twitter.com/intent/follow?screen_name=TOIBusiness';
    } else if (sectionName === 'world') {
      twitterFollowUrl =
        'https://twitter.com/intent/follow?screen_name=TOIWorld';
    } else if (sectionName === 'sports') {
      twitterFollowUrl =
        'https://twitter.com/intent/follow?screen_name=toisports';
    }
    if (isEtimes) {
      twitterFollowUrl = 'https://twitter.com/intent/follow?screen_name=etimes';
    }
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'twitter',
      label: 'btf_share',
    });
    window.open(twitterFollowUrl, '_blank');
  }

  followOnInstagram() {
    const { gaCategory, gaAction, gaIndex, sectionName, isEtimes } = this.props;
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: gaAction || 'instagram',
        gaLabel: `${gaIndex}instagram`,
      },
    });
    let instaFollowUrl =
      'https://instagram.com/timesofindia?igshid=YmMyMTA2M2Y=';
    if (sectionName === 'sports') {
      instaFollowUrl = 'https://instagram.com/toi_sports?igshid=YmMyMTA2M2Y=';
    }
    if (isEtimes) {
      instaFollowUrl = 'https://instagram.com/etimes/';
    }
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'instagram',
      label: 'btf_share',
    });
    window.open(instaFollowUrl, '_blank');
  }

  followOnKoo() {
    const { gaCategory, gaAction, gaIndex, sectionName, isEtimes } = this.props;
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: gaAction || 'koo',
        gaLabel: `${gaIndex}koo`,
      },
    });
    let kooFollowUrl =
      'https://www.kooapp.com/profile/timesofindia?utm_source=timesofindia&utm_campaign=timesofindia_follow';
    if (sectionName === 'sports') {
      kooFollowUrl =
        'https://www.kooapp.com/profile/TOISports?utm_source=TOISports&utm_campaign=TOISports_follow';
    }
    if (isEtimes) {
      kooFollowUrl = 'https://www.kooapp.com/profile/etimes';
    }
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'koo',
      label: 'btf_share',
    });
    window.open(kooFollowUrl, '_blank');
  }

  followOnGoogleNews() {
    const { gaCategory, gaAction, gaIndex, isEtimes } = this.props;
    sendGaThroughProps({
      data: {
        gaCategory,
        gaAction: gaAction || 'google_news',
        gaLabel: `${gaIndex}google_news`,
      },
    });
    let googleNewsFollowUrl =
      'https://news.google.com/publications/CAAqBwgKMM6y_Qowwu70Ag';
    if (isEtimes) {
      googleNewsFollowUrl =
        'https://news.google.com/publications/CAAqBwgKMKrsugswt4fSAw';
    }
    analyticsWrapper('ga4', {
      event: 'user_click',
      type: 'social_share',
      category: 'google',
      label: 'btf_share',
    });
    window.open(googleNewsFollowUrl, '_blank');
  }

  getDivId = () => {
    let divId = this.props.isParent
      ? 'widget-two'
      : `tpwidget-${this.props.msid}${
          this.props.type ? `-${this.props.type}` : ''
        }`;
    if (this.props.sticky) {
      divId = 'widget-tp-sticky';
    } else if (this.props.type && this.props.isParent) {
      divId = `widget-two-${this.props.type}`;
    }

    this.divId = divId;

    return divId;
  };

  getUtmDetail = (utm, channel, url) => {
    const platform = this.props.isWapView ? 'mWeb_social' : 'web_social';
    const utmParams = `utm_source=${channel}&utm_medium=${platform}&utm_campaign=social_share`;
    //GA4 Events
    const { msid, platformTemplate } = this.props;

    if (platformTemplate !== '' && channel !== '') {
      analyticsWrapper('ga4', {
        event: 'share',
        method: channel,
        entity_type: platformTemplate,
        ...(msid && msid !== undefined ? { item_id: msid } : {}),
      });
    }
    // Check if URL already contains '?'
    if (!url || typeof url !== 'string') return `?${utmParams}`;
    const separator = url.includes('?') ? '&' : '?';
    return `${separator}${utmParams}`;

    // if (typeof utm !== 'string') return '';
    // if (utm.indexOf('####') > -1) {
    //   return utm.replace('####', channel);
    // }
    // return utm;
  };

  render() {
    const divId = this.getDivId();
    const { gaCategory, gaAction = '', gaIndex = '' } = this.props;
    // const { gaAction = '' } = this.props;
    // const { gaIndex = ''} = this.props;
    // const { gaLabel = '' } = this.props;
    const webcss = this.props.styles || {};
    const {
      textRequired,
      tpShow,
      whatsAppShow,
      linkeDin,
      showComment,
      commentsCount,
      topsticky,
      wrapperClass,
      whatsAppCssOverride,
      tpCssOverride,
      showWhatsappNativeShareTP,
      hideemail,
      hideSharingButtons,
      showFollowButtons,
      commentModeration,
    } = this.props;
    const { url, title, msid, isWapView } = this.props;

    return (
      <>
        <div
          className={`${s.social_sharing} ${webcss.social_sharing} ${
            textRequired ? webcss.socialSharingWithText : ''
          } ${topsticky ? webcss.topsticky : ''} ${wrapperClass || ''} ${this
            .props.isSmallicon && s.smallsocialicons}`}
        >
          {/* {tpShow && <span className={`${webcss.timespoint}`}>99 Points</span>} */}
          {/* <div className={`${s.icon_share}`}>
              <i
                className={`${s.shareicon} ${
                  this.state.showSocialWidget ? s.active : ''
                }`}
              />
              <span>Share</span>
          </div> */}
          {/* <div className={`${s.gnews} ${s.gnews_top}`}>
            <Links
              href="https://news.google.com/publications/CAAqBwgKMM6y_Qowwu70Ag?hl=en-IN&gl=IN&ceid=IN%3Aen"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                sendGaThroughProps({
                  data: {
                    gaCategory: this.props.categoryForGA,
                    gaAction: 'user_click',
                    gaLabel: 'google_news',
                  },
                });
              }}
            >
              Follow us <i />
            </Links>
          </div> */}
          {/* {tpShow &&
            !isWapView &&
            this.state.showInGeo && (
              <span
                data-tpwidget="widget-two"
                id={divId}
                className={`${s.tp_icon} ${webcss.timespoint} ${tpCssOverride}`}
                data-ga={`${gaCategory}|${gaAction ||
                  'times_point'}|${gaIndex}times_point`}
                onClick={e => this.gaClickHandler(e)}
              />
            )} */}

          {tpShow && isWapView && this.state.showInGeo}
          {/* {tpShow &&
            isWapView &&
            this.state.showInGeo && (
              <a
                href="/timespoints"
                data-tpwidget="widget-two"
                id={divId}
                className={`${s.tp_icon} ${webcss.timespoint} ${tpCssOverride}`}
                data-ga={`${gaCategory}|${gaAction ||
                  'times_point'}|${gaIndex}times_point`}
                onClick={e => this.gaClickHandler(e)}
              />
            )} */}
          {!hideSharingButtons &&
            !showWhatsappNativeShareTP && (
              <>
                <span
                  className={`${s.facebook} ${webcss.facebook} ${
                    this.props.isAuthorWidget && url?.fb === ''
                      ? s.displayNone
                      : ''
                  }`}
                  data-ga={`${gaCategory}|${gaAction ||
                    'facebook'}|${gaIndex}facebook`}
                  data-ga4={
                    !!this.props.ga4Data &&
                    JSON.stringify([
                      { ...this.props.ga4Data, label: 'facebook' },
                    ])
                  }
                  onClick={e => this.shareOnFb(e, this.props.msid)}
                >
                  {textRequired && 'Facebook'}
                </span>
                <span
                  className={`${s.twitter} ${webcss.twitter}  ${
                    this.props.isAuthorWidget && url?.twitter === ''
                      ? s.displayNone
                      : ''
                  }`}
                  data-ga={`${gaCategory}|${gaAction ||
                    'twitter'}|${gaIndex}twitter`}
                  data-ga4={
                    !!this.props.ga4Data &&
                    JSON.stringify([
                      { ...this.props.ga4Data, label: 'twitter' },
                    ])
                  }
                  onClick={e => this.shareOnTwitter(e, this.props.msid)}
                >
                  {textRequired && 'Twitter'}
                </span>
              </>
            )}
          {showFollowButtons && (
            <>
              <span
                className={`${s.gnews} ${webcss.gnews}`}
                onClick={e => this.followOnGoogleNews(e)}
                data-ga4={
                  this.props.ga4Data &&
                  JSON.stringify([{ ...this.props.ga4Data, label: 'google' }])
                }
              >
                {textRequired && 'Google'}
              </span>
              <span
                className={`${s.facebook} ${webcss.facebook}`}
                onClick={e => this.likeOnFb(e)}
              >
                {textRequired && 'Facebook'}
              </span>
              <span
                className={`${s.twitter} ${webcss.twitter}`}
                onClick={e => this.followOnTwitter(e)}
              >
                {textRequired && 'Twitter'}
              </span>
              <span
                className={`${s.instagram} ${webcss.instagram}`}
                onClick={e => this.followOnInstagram(e)}
              >
                {textRequired && 'Instagram'}
              </span>
              {/* <span
                className={`${s.kooapp} ${webcss.kooapp}`}
                onClick={e => this.followOnKoo(e)}
              >
                {textRequired && 'KOO APP'}
              </span> */}
              <span
                className={`${s.youtube} ${webcss.youtube}`}
                onClick={e => this.followOnYoutube(e)}
              >
                {textRequired && 'Youtube'}
              </span>
              <span
                className={`${s.telegram} ${webcss.telegram}`}
                onClick={e => this.followOnTelegram(e)}
              >
                {textRequired && 'Telegram'}
              </span>
            </>
          )}
          {!hideSharingButtons &&
            linkeDin && (
              <span
                className={`${s.linkedin} ${webcss.linkedin}`}
                data-ga={`${gaCategory}|${gaAction ||
                  'linkedin'}|${gaIndex}linkedin`}
                data-ga4={
                  !!this.props.ga4Data &&
                  JSON.stringify([{ ...this.props.ga4Data, label: 'linkedin' }])
                }
                onClick={e => this.shareOnLinkedin(e)}
              >
                {textRequired && 'Linkedin'}
              </span>
            )}
          {!hideSharingButtons &&
            !showWhatsappNativeShareTP &&
            !hideemail && (
              <span
                className={`${s.mail} ${webcss.mail}`}
                data-ga={`${gaCategory}|${gaAction || 'email'}|${gaIndex}email`}
                data-ga4={
                  !!this.props.ga4Data &&
                  JSON.stringify([{ ...this.props.ga4Data, label: 'email' }])
                }
                onClick={e =>
                  this.props.isWapView || this.props.defaultEmailView
                    ? this.handleEmailClick(e)
                    : this.openEmailPopup(e)
                }
              >
                {textRequired && 'EMail'}
              </span>
            )}
          {!hideSharingButtons &&
            whatsAppShow && (
              <span
                className={`${s.whatsapp} ${
                  webcss.whatsapp
                } ${whatsAppCssOverride}`}
                data-ga={`${gaCategory}|${gaAction ||
                  'whatsapp'}|${gaIndex}whatsapp`}
                onClick={e => this.shareOnWhatsapp(e)}
              />
            )}
          {this.props.isWapView && this.props.sticky && this.props.children}
          {showComment &&
            isWapView &&
            commentsCount >= 0 &&
            !(commentModeration === '4.0' || commentModeration === '3.0') && (
              <Link
                className={s.comment}
                href="javascript: void(0)"
                // to={`https://m.timesofindia.com/articleshow_comments/${
                //   this.props.msid
                // }.cms`}
                onClick={this.openSidebar}
                data-ga={`${gaCategory}|${gaAction ||
                  'comments'}|${gaIndex}comments`}
              >
                <span>{commentsCount}</span>
              </Link>
            )}
          {showComment &&
            !isWapView &&
            commentsCount > 0 && (
              <Link
                href="javascript: void(0)"
                className={s.comment}
                data-ga={`${gaCategory}|${gaAction ||
                  'comments'}|${gaIndex}comments`}
                onClick={this.openSidebar}
              >
                <span>{commentsCount}</span>
              </Link>
            )}
          {!(
            this.props.isWapView &&
            this.props.sticky &&
            !showWhatsappNativeShareTP
          ) && this.props.children}
        </div>

        {/* {this.state.openEmailPopUp ? <div className={s.emailoverlay} /> : null} */}
        {!hideSharingButtons &&
          this.state.openEmailPopUp && (
            <ErrorBoundary>
              <PopupPortal usePopupPortal>
                <EmailSharing
                  url={url}
                  title={title || toiTitle}
                  msid={msid}
                  successMsgTitle="Thank you!"
                  successMsgText="Your email with the article link has been sent."
                  closeEmailPopup={this.closeEmailPopup}
                  isMailHeadingAvailable={this.props.liveblogMailHeading}
                />
              </PopupPortal>
            </ErrorBoundary>
          )}
      </>
    );
  }
}

SocialWidget.propTypes = {
  styleObj: PropTypes.shape({}).isRequired,
  url: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  image: PropTypes.shape({}).isRequired,
  openSidebar: PropTypes.func.isRequired,
  msid: PropTypes.string.isRequired,
  via: PropTypes.string.isRequired,
  wu: PropTypes.string.isRequired,
  isTablet: PropTypes.func.isRequired,
  isWapView: PropTypes.bool,
  textRequired: PropTypes.bool,
  tpShow: PropTypes.bool,
  whatsAppShow: PropTypes.bool,
  linkeDin: PropTypes.bool,
  topsticky: PropTypes.bool,
  styles: PropTypes.shape({}),
  isParent: PropTypes.bool,
  commentsCount: PropTypes.number,
  showComment: PropTypes.bool,
  wrapperClass: PropTypes.string,
  children: PropTypes.node,
  gaCategory: PropTypes.string,
  sticky: PropTypes.bool,
  type: PropTypes.string,
  forceOpenSidebar: PropTypes.bool,
  socialWidgetToggle: PropTypes.func,
  // gaLabel: PropTypes.string,
  gaAction: PropTypes.string,
  liveblogMailHeading: PropTypes.string,
  showWhatsappNativeShareTP: PropTypes.bool,
  hideemail: PropTypes.bool,
  whatsAppCssOverride: PropTypes.string,
  tpCssOverride: PropTypes.string,
  defaultEmailView: PropTypes.bool,
  utm: PropTypes.string,
  disableShortUrl: PropTypes.bool,
  gaIndex: PropTypes.string,
  hideSharingButtons: PropTypes.bool,
  showFollowButtons: PropTypes.bool,
  sectionName: PropTypes.string,
  isEtimes: PropTypes.bool,
  commentModeration: PropTypes.string,
  isAuthorWidget: PropTypes.bool,
  isLiveBlog: PropTypes.bool,
  platformTemplate: PropTypes.string,
};

SocialWidget.defaultProps = {
  isWapView: false,
  textRequired: false,
  tpShow: false,
  whatsAppShow: false,
  linkeDin: false,
  topsticky: false,
  styles: {},
  isParent: false,
  commentsCount: null,
  showComment: false,
  wrapperClass: '',
  children: null,
  gaCategory: 'share',
  sticky: false,
  type: '',
  forceOpenSidebar: false,
  socialWidgetToggle: undefined,
  // gaLabel: '',
  liveblogMailHeading: undefined,
  showWhatsappNativeShareTP: false,
  whatsAppCssOverride: '',
  tpCssOverride: '',
  defaultEmailView: false,
  utm: '',
  disableShortUrl: false,
  gaAction: '',
  gaIndex: '',
  hideemail: false,
  hideSharingButtons: false,
  showFollowButtons: false,
  sectionName: '',
  isEtimes: false,
  commentModeration: '',
  isAuthorWidget: false,
  isLiveBlog: false,
  platformTemplate: '',
};

export default SocialWidget;
